// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"style__breadcrumbs___36pV1","current":"style__current___2p8gl","groupLink":"style__groupLink___ZPaBr","truncate":"style__truncate___38ayQ"};